import { render, staticRenderFns } from "./selfLesWin.vue?vue&type=template&id=2821b747&"
import script from "./selfLesWin.vue?vue&type=script&lang=js&"
export * from "./selfLesWin.vue?vue&type=script&lang=js&"
import style0 from "./selfLesWin.vue?vue&type=style&index=0&id=2821b747&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports